/**
 * Phase 20 — the master config editor's Save that switches its campaign
 * group's auto-send ON asks first, with the settings as they will be after
 * Save: real SMS (or what this server really does), the group's drafts due
 * today, its stop-loss, its cap, and that Kill stops every group.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import type { ContainerDraft, DropGenPlanDetail } from '../../../drop-generator.types';
import { useSchedulerStatus } from '../../../useDropGenerator';
import { AutoSendConfirmDialog } from '../../board-header/autosend/AutoSendConfirmDialog';
import { liveKind } from '../../board-header/autosend/groups/mode-options';
import { draftConfig } from './autosend-slice';

export const AutoSendSaveConfirm: FC<{
  open: boolean;
  plan: DropGenPlanDetail;
  draft: ContainerDraft;
  /** The master config's id; null while it is new (nothing is due yet). */
  masterId: string | null;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ open, plan, draft, masterId, busy, onConfirm, onCancel }) => {
  const status = useSchedulerStatus().data;
  const today = status?.plans.find((p) => p.countryKey === plan.countryKey)?.groups.find((g) => g.masterId === masterId)?.sendToday ?? null;
  if (!open) return null;
  const name = draft.name || 'this campaign group';
  return (
    <AutoSendConfirmDialog
      open
      plan={plan}
      layer={{ id: masterId ?? 'new', kind: 'group', name, groupName: name, config: draftConfig(draft) }}
      today={today}
      mode={liveKind(status?.sendModes)}
      busy={busy}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
